import React from "react";
import CardSection from "../../../components/ui/CardSection";
import Photo from "../../../components/ui/Photo";
import { ISaleProduct } from "../../../classes/interfaces";
import {
  List,
  Row,
  Thumb,
  Info,
  Name,
  ExtrasGroupLabel,
  ExtraLine,
  Note,
  BottomLine,
  Qty,
  Price,
} from "./ProductsList.styles";
import { formatBRL } from "../../../helpers/currency.helper";

interface ProductsListProps {
  products: ISaleProduct[];
}

function getAdicionais(product: ISaleProduct) {
  let stepId = "";
  let prefix = "";
  return product.extras.map((extra) => {
    if (stepId !== (extra.step?.id || "-1")) {
      stepId = extra.step?.id || "-1";
      prefix = extra.step?.name || "Adicionais";
      prefix += ":";
      return (
        <React.Fragment key={stepId}>
          <ExtrasGroupLabel>{prefix}</ExtrasGroupLabel>
          {product.extras.map((ex) => {
            if ((ex.step?.id || "-1") === stepId) {
              return (
                <ExtraLine key={ex.extra.id}>
                  {ex.amount.toString() + "X " + ex.extra.name}
                </ExtraLine>
              );
            }
            return undefined;
          })}
        </React.Fragment>
      );
    }
    return undefined;
  });
}

export default function ProductsList({ products }: ProductsListProps) {
  return (
    <CardSection icon="bag" title="Produtos">
      <List>
        {products.map((product, index) => (
          <Row key={index}>
            <Thumb>
              <Photo src={product.imageUrl || undefined} label={product.name} radius={13} />
            </Thumb>
            <Info>
              <Name>{product.name}</Name>
              {getAdicionais(product)}
              {product.note && product.note !== "" ? (
                <Note>{"Observação: " + product.note}</Note>
              ) : null}
              <BottomLine>
                <Qty>{product.amount}×</Qty>
                <Price>{formatBRL(product.total)}</Price>
              </BottomLine>
            </Info>
          </Row>
        ))}
      </List>
    </CardSection>
  );
}
